import Index from 'components/ckan/hosting/Index.jsx'
import React from "react";



export default function CKANHostingPage({casestudies}){
  return(
  <Index />
)}

export async function getStaticProps() {
  return {
    props: {
      meta: {
        title: "CKAN Hosting",
        description: "Reliable, easy hosting from CKAN’s creators. With over a decade’s experience, we make managing CKAN simple.",
      },
    },
  };
};